/* eslint-disable quotes */

// components.application.dashboard.summaries.rewardStatus

export const REWARD_STATUS = {
  title: 'Rewards Status',
  description: 'Total points earned'
};
